/**
 * @generated SignedSource<<e209ef860b78e47b62f83be47520e1e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeedOrdering = "BEST" | "LEAST_COMMENTED" | "MOST_COMMENTED" | "NEWEST" | "OLDEST" | "TRENDING" | "%future added value";
export type comunidadeFeedFragmentQuery$variables = {
  club: string;
  cursor?: string | null | undefined;
  first?: number | null | undefined;
  id: string;
  order?: FeedOrdering | null | undefined;
};
export type comunidadeFeedFragmentQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"comunidadeFeedFragment">;
  } | null | undefined;
};
export type comunidadeFeedFragmentQuery = {
  response: comunidadeFeedFragmentQuery$data;
  variables: comunidadeFeedFragmentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "club"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v2 = {
  "defaultValue": 10,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v4 = {
  "defaultValue": "NEWEST",
  "kind": "LocalArgument",
  "name": "order"
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v6 = {
  "kind": "Variable",
  "name": "club",
  "variableName": "club"
},
v7 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v7/*: any*/),
  {
    "kind": "Literal",
    "name": "ignoreFixed",
    "value": false
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "order"
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedUrl",
  "storageKey": null
},
v16 = [
  (v15/*: any*/),
  (v9/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawID",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "playback",
  "storageKey": null
},
v19 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "comunidadeFeedFragmentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              (v6/*: any*/),
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              },
              (v7/*: any*/),
              {
                "kind": "Variable",
                "name": "order",
                "variableName": "order"
              }
            ],
            "kind": "FragmentSpread",
            "name": "comunidadeFeedFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "comunidadeFeedFragmentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v10/*: any*/),
                "concreteType": "FeedItemConnection",
                "kind": "LinkedField",
                "name": "feed",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FeedItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "title",
                                    "storageKey": null
                                  },
                                  (v11/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      (v11/*: any*/),
                                      (v9/*: any*/),
                                      (v12/*: any*/),
                                      (v13/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "scheduledPublishDate",
                                    "storageKey": null
                                  },
                                  (v14/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PostVote",
                                    "kind": "LinkedField",
                                    "name": "userVote",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "vote",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "commentCount",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "displayName",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "username",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "avatarFallback",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": [
                                          (v6/*: any*/)
                                        ],
                                        "concreteType": "Badge",
                                        "kind": "LinkedField",
                                        "name": "badges",
                                        "plural": true,
                                        "selections": [
                                          (v9/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "text",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "textColor",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "bgColor",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ImageFile",
                                        "kind": "LinkedField",
                                        "name": "photo",
                                        "plural": false,
                                        "selections": (v16/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "votes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Club",
                                    "kind": "LinkedField",
                                    "name": "club",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v11/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SpaceGroup",
                                        "kind": "LinkedField",
                                        "name": "groups",
                                        "plural": true,
                                        "selections": [
                                          (v9/*: any*/),
                                          (v12/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "spaces",
                                            "plural": true,
                                            "selections": [
                                              (v8/*: any*/),
                                              (v9/*: any*/),
                                              (v12/*: any*/),
                                              (v13/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "createdAt",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "pinned",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "pinnedUniversal",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "content",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "coverContent",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v14/*: any*/)
                                        ],
                                        "type": "ExternalVideoCover",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v9/*: any*/),
                                          (v17/*: any*/),
                                          (v12/*: any*/),
                                          (v15/*: any*/)
                                        ],
                                        "type": "ImageFile",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v9/*: any*/),
                                          (v17/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "muxId",
                                            "storageKey": null
                                          },
                                          (v14/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "status",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ImageFile",
                                            "kind": "LinkedField",
                                            "name": "thumbnail",
                                            "plural": false,
                                            "selections": (v16/*: any*/),
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "VideoPlayback",
                                            "kind": "LinkedField",
                                            "name": "playback",
                                            "plural": false,
                                            "selections": [
                                              (v18/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "VideoFileTokens",
                                                "kind": "LinkedField",
                                                "name": "tokens",
                                                "plural": false,
                                                "selections": [
                                                  (v18/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "storyboard",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "thumbnail",
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "VideoFile",
                                        "abstractKey": null
                                      },
                                      (v8/*: any*/),
                                      (v19/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Attachment",
                                    "kind": "LinkedField",
                                    "name": "attachments",
                                    "plural": true,
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "originalName",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "size",
                                        "storageKey": null
                                      },
                                      (v15/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "Post",
                                "abstractKey": null
                              }
                            ],
                            "type": "ContentInterface",
                            "abstractKey": "__isContentInterface"
                          },
                          (v8/*: any*/),
                          (v19/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v10/*: any*/),
                "filters": [
                  "orderBy",
                  "ignoreFixed"
                ],
                "handle": "connection",
                "key": "comunidadeFeedFragment_feed",
                "kind": "LinkedHandle",
                "name": "feed"
              }
            ],
            "type": "Club",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1c5d8f60092268e79a7a408f0e1372f8",
    "id": null,
    "metadata": {},
    "name": "comunidadeFeedFragmentQuery",
    "operationKind": "query",
    "text": "query comunidadeFeedFragmentQuery(\n  $club: String!\n  $cursor: String\n  $first: Int = 10\n  $order: FeedOrdering = NEWEST\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...comunidadeFeedFragment_2rtMtm\n    id\n  }\n}\n\nfragment comunidadeFeedFragment_2rtMtm on Club {\n  feed(after: $cursor, first: $first, orderBy: $order, ignoreFixed: false) {\n    edges {\n      node {\n        ... on ContentInterface {\n          __isContentInterface: __typename\n          ... on Post {\n            id\n            ...postPreviewFragment_4bIyVY\n          }\n        }\n        __typename\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n  }\n  id\n}\n\nfragment memberBadgeFragment on Badge {\n  text\n  textColor\n  bgColor\n}\n\nfragment postAttachmentsPreview_post on Post {\n  id\n  attachments {\n    id\n    originalName\n    size\n    signedUrl\n  }\n}\n\nfragment postBottomActionsFragment on Post {\n  id\n  slug\n  url\n  space {\n    __typename\n    slug\n    id\n  }\n  userVote {\n    vote\n  }\n  commentCount\n  author {\n    id\n  }\n  votes\n}\n\nfragment postContentPreviewFragment on Post {\n  content\n}\n\nfragment postCoverFragment on Post {\n  coverContent {\n    ... on ExternalVideoCover {\n      url\n    }\n    ... on ImageFile {\n      id\n      rawID\n      name\n      signedUrl\n    }\n    ... on VideoFile {\n      id\n      rawID\n      muxId\n      url\n      status\n      thumbnail {\n        signedUrl\n        id\n      }\n      playback {\n        playback\n        tokens {\n          playback\n          storyboard\n          thumbnail\n        }\n      }\n    }\n    __typename\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  id\n}\n\nfragment postHeaderFragment_4bIyVY on Post {\n  id\n  slug\n  author {\n    id\n    displayName\n    username\n    avatarFallback\n    badges(club: $club) {\n      id\n      ...memberBadgeFragment\n    }\n    photo {\n      signedUrl\n      id\n    }\n  }\n  space {\n    __typename\n    id\n    name\n    icon\n    slug\n  }\n  club {\n    id\n    slug\n  }\n  createdAt\n  pinned\n  pinnedUniversal\n  ...postMoveDialogQuery\n}\n\nfragment postMoveDialogQuery on Post {\n  id\n  space {\n    __typename\n    id\n  }\n  club {\n    slug\n    groups {\n      id\n      name\n      spaces {\n        __typename\n        id\n        name\n        icon\n      }\n    }\n    id\n  }\n}\n\nfragment postPreviewFragment_4bIyVY on Post {\n  title\n  slug\n  space {\n    __typename\n    slug\n    id\n  }\n  scheduledPublishDate\n  ...postBottomActionsFragment\n  ...postHeaderFragment_4bIyVY\n  ...postContentPreviewFragment\n  ...postCoverFragment\n  ...postAttachmentsPreview_post\n}\n"
  }
};
})();

(node as any).hash = "18d903db0fc76d4f23f1607c5db7e30b";

export default node;
